import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL, IMAGE_URL } from '../Component/Baseurl';
import defaultImage from './img/event1.jfif';  
import ban1 from './img/ban2.jpg';  
import { Link } from 'react-router-dom'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import phrama from "./img/pharma.jpg";
import food from "./img/food.png";
import oil from "./img/oil.jpg";
import auto from "./img/robotic.png";
import automotive from "./img/auto.png";
import agricutre from "./img/agri.webp";


function IndustryCompo() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(`${BASE_URL}GetAllExhibitions`);

        // Log the API response to the console
        console.log('API Response:', response);

        if (response.data.exhibitions) {
          setEvents(response.data.exhibitions.slice(0, 8)); // Only fetch 8 events
        } else {
          setError('Failed to fetch exhibitions');
        }

        setLoading(false); // Stop the loader
      } catch (error) {
        console.error('Error fetching exhibitions:', error);
        setError('Error fetching exhibitions');
        setLoading(false); // Stop the loader
      }
    };

    fetchEvents();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="ms-3">Loading Content...</p>
      </div>
    );
  }

  if (error) return <p>{error}</p>;

  return (
    <>
      <section className="bg-light pt-3">
        <div className="row g-1">
            <div className="col-8">
              <h2 className="text-start hedng mb-3">Popular Industries</h2>
            </div>
            <div className="col-4 text-end">
              <Link to="/filter/country/India" className="text-end viewall">
                View All <FontAwesomeIcon icon={faArrowRight} />
              </Link>
            </div>
          </div>

        <div className=" container-fluid">
          

          <div className="row g-3">
            <div className="col-md-2">
              <Link to="/filter/industry/Chemicals">
              <div className='cdgh d-flex justify-content-between align-items-center p-2'>
                <div className='text-start me-2'>
                  <img src={phrama} className='img-fluid indimg'/>
                </div>
                <h4 className='cdkl1'>Pharma & Chemical</h4>
              </div>
              </Link>
            </div>

            <div className="col-md-2">
              <Link to="/filter/industry/Food%20%26%20Beverages">
              <div className='cdgh d-flex justify-content-between align-items-center p-2'>
                <div className='text-start'>
                  <img src={food} className='img-fluid indimg'/>
                   </div>
                <h4 className='cdkl1'>Food & Breverages</h4>
              </div>
              </Link>
            </div>


            <div className="col-md-2">
              <Link to="/filter/industry/Oil%20and%20Gas%2C%20Petrochemicals">
              <div className='cdgh d-flex justify-content-between align-items-center p-2'>
                <div className='text-start'>
                  <img src={oil} className='img-fluid indimg'/>
                  </div>
                <h4 className='cdkl1'>Oil & Gases & Power</h4>
              </div>
              </Link>
            </div>


            <div className="col-md-2">
              <Link to="/filter/industry/Manufacturing">
              <div className='cdgh d-flex justify-content-between align-items-center p-2'>
                <div className='text-start'>
                  <img src={auto} className='img-fluid indimg'/>
                    </div>
                <h4 className='cdkl1'>Automation & Manufacturing</h4>
              </div>
              </Link>
            </div>


            <div className="col-md-2">
              <Link to="/filter/industry/Auto%20%26%20Automotive">
              <div className='cdgh d-flex justify-content-between align-items-center p-2'>
                <div className='text-start'>
                   <img src={automotive} className='img-fluid indimg'/>
                    </div>
                <h4 className='cdkl1'>Auto & Automotive</h4>
              </div>
              </Link>
            </div>

            <div className="col-md-2">
              <Link to="/filter/industry/Agriculture%20%26%20Forestry%2C%20Agro">
              <div className='cdgh d-flex justify-content-between align-items-center p-2'>
                <div className='text-start'>
                  <img src={agricutre} className='img-fluid  indimg'/>
                   </div>
                <h4 className='cdkl1'>Agriculture & Forestry</h4>
              </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default IndustryCompo;
